import { CardHistoryWebComponent } from './component/CardHistoryWebComponent';
import { WEB_COMPONENT_CARD_HISTORY } from '../../webcomponents.constants';

export { CardHistoryWebComponent };

window.customElements.define(WEB_COMPONENT_CARD_HISTORY, CardHistoryWebComponent);
